import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@totalsoft/rocket-ui';

function ApprovalTypeHeader() {
  const { t } = useTranslation();
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {t('ApprovalTypes.GeneralData')}
    </Typography>
  );
}

export default ApprovalTypeHeader;
